<template>
    <access-denied v-if="accessDenied" title="cliente" />
    <div v-else>
        <div class="listing-header mb-4">
            <div class="title-breadcrumb"></div>
            <div class="header-buttons">
                <button
                    v-if="(!isUpdate && permissao.create) || (isUpdate && permissao.update)"
                    @click="save()"
                    :disabled="isSaving"
                    class="save-btn"
                    type="button"
                >
                    {{ $t('salvar') }}
                    <button-loader :isSaving="isSaving" />
                </button>
            </div>
        </div>

        <div class="page-container form-columns-fit">
            <div class="columns is-flex-wrap">
                <div class="column is-3">
                    <v-input
                        ref="idrotaerpInput"
                        v-model="rota.idrotaerp"
                        placeholder="placeholder-preencha"
                        :maxlength="30"
                        title="codigo"
                        uppercase
                        msg="msg-campo-obrigatorio"
                        :invalid="isNull(rota.idrotaerp)"
                        :disabled="isSaving"
                        required
                    />
                </div>
                <div class="column is-9">
                    <v-input
                        ref="descricaoInput"
                        v-model="rota.descricao"
                        placeholder="titulo-da-rota-placeholder"
                        :maxlength="100"
                        title="titulo-da-rota"
                        msg="msg-campo-obrigatorio"
                        :invalid="isNull(rota.descricao)"
                        :disabled="isSaving"
                        required
                    />
                </div>

                <div class="column is-9">
                    <vss-select
                        ref="promotorSelect"
                        :value="promotorSelected"
                        searchable
                        title="promotor"
                        :tooltipLabel="$t('msg-promotor-rota')"
                        :options="promotorList"
                        @search="carregarDadosColaborador"
                        @input="updatePromotor"
                        placeholder="promotor-rota-placeholder"
                        :disabled="isSaving"
                        :loading="promotorLoading"
                        required
                        :invalid="promotorSelected == null"
                    />
                </div>

                <div class="column is-3">
                    <vss-select
                        title="situacao"
                        ref="situacaoSelect"
                        :options="situacoes"
                        :value="situacao"
                        @input="updateSituacao"
                        :mlLabels="true"
                        placeholder="situacao-da-marca-placeholder"
                        :disabled="isSaving"
                        required
                    />
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import RotaService from '@/services/promotor/RotaService.js';
import ColaboradorService from '@/services/ColaboradorService.js';
import RotaValidation from '@/services/validations/promotor/RotaValidation.js';
import Message from '@/models/Message.js';

export default {

    props: {
        permissao: {
            type: Object,
            default: () => {},
        },
        isUpdate: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            accessDenied: false,
            msgs: [],
            service: new RotaService(this.$http, this.$router),
            colaboradorService: new ColaboradorService(this.$http, this.$router),
            validation: new RotaValidation(this.msgs),
            rota: {
                idrota: 0,
                idrotaerp: null,
                // pega o domingo da semana atual
                datainicio: this.$moment().day(0).toDate(),
                periodo: 7,
                situacao: 1,
                idusuario: null,
                usuario: null,
            },
            // periodoSelected: { label: 'semanal', periodo: 7 },
            // periodoSelect: [
            //     { label: 'semanal', periodo: 7 },
            //     { label: 'quinzenal', periodo: 14 },
            // ],
            situacao: { label: 'ativo', id: 1 },
            situacoes: [
                { label: 'ativo', id: 1 },
                { label: 'inativo', id: 0 },
            ],
            isSaving: false,
            isLoading: false,
            promotorLoading: false,
            promotorSelected: null,
            promotorList: [],
        };
    },
    created() {
        if (!this.permissao.read) {
            this.accessDenied = true;
            return;
        }
        this.carregarDadosColaborador();
        if (this.isUpdate) {
            this.carregarDados();
        } else {
            setTimeout(() => {
                this.$emit('isChanged', false);
            }, 2500);
        }

        this.$on('update-data', (value) => {
            this.promotorSelected = value.id;
        });
    },
    watch: {
        rota: {
            deep: true,
            handler: function () {
                this.sendIsChanged('watch');
            },
        },
    },
    methods: {
        sendIsChanged(cameFrom = null) {
            // console.log('sendIsChanged', cameFrom);
            if (this.rota.idrota == null && this.isUpdate) this.$emit('isChanged', false);
            if (!this.isLoading) this.$emit('isChanged', true);
        },
        carregarDadosColaborador(search) {
            this.promotorLoading = true;
            this.colaboradorService
                .findAllNotInRoute(0, 10, search)
                .then(this.mapPromotores)
                .catch((e) => {
                    this.promotorLoading = false;
                    this.$root.msgs.push(new Message('error', 'msg-erro-load', true));
                })
                .then((allpromotores) => {
                    this.promotorList = [];
                    let pro = allpromotores.filter(
                        (c) => this.promotorSelected && c.id == this.promotorSelected.idusuario
                    )[0];
                    if (this.promotorSelected && !pro) {
                        allpromotores.push(this.promotorSelected);
                    }
                    this.promotorList = allpromotores;
                    this.promotorList.sort();
                }, 350)
                .finally(() => {
                    this.promotorLoading = false;
                });
        },
        mapPromotores(body) {
            const promotorList = body.content.map((p) => {
                return {
                    id: p.idusuario,
                    label: p.nome,
                    fullData: p,
                };
            });
            return promotorList;
        },
        carregarDados() {
            this.isLoading = true;
            this.service
                .find(this.$route.params.id)
                .then((body) => {
                    this.rota = body.content;

                    this.situacao = this.situacoes.find((s) => s.id == this.rota.situacao);

                    if (this.rota.usuario) {
                        this.promotorSelected = {
                            id: this.rota.usuario.idusuario,
                            label: this.rota.usuario.nome,
                            fullData: this.rota.usuario,
                        };
                    }

                    if (this.promotorSelected && this.promotorSelected.fullData) {
                        this.promotorList.push(this.promotorSelected);
                    }

                    this.rota.datainicio = this.$moment().day(0).toDate();
                })
                .catch((e) => {
                    this.$root.msgs.push(new Message('error', 'msg-problema-realizar-acao', true));
                })
                .finally((_) => {
                    this.isLoading = false;
                    this.$emit('rota', this.rota);
                });
        },
        updateSituacao(situacao) {
            if (situacao && situacao.id != null) {
                this.rota.situacao = situacao.id;
                this.situacao = situacao;
            }
            if (situacao.id == 0) {
                this.rota.usuariosinrotas = 0;
            }
        },
        updatePromotor(promotorSelected) {
            if (promotorSelected) {
                this.promotorSelected = promotorSelected;
                this.rota.usuario = promotorSelected.fullData;
                this.mapcenter = {
                    lat: this.rota.usuario.latitude,
                    lng: this.rota.usuario.longitude,
                    tipo: 'promotorSelected',
                    id: this.rota.usuario,
                };
            } else {
                this.promotorSelected = null;
                this.rota.usuario = null;
                this.mapcenter = {
                    lat: this.position.coords.latitude,
                    lng: this.position.coords.longitude,
                    tipo: 'cidade',
                };
            }
        },
        save() {
            this.rota = this.mapTosave(this.rota);

            this.rota.idusuario = this.promotorSelected != null ? this.promotorSelected.id : null;

            if (this.validation.validate(this.rota, this.$refs, this.$root)) {
                this.isSaving = true;

                this.service
                    .save(this.rota)
                    .then((body) => {
                        if (body.content != null) {
                            let msg = this.rota.idrota ? 'msg-rota-edita' : 'msg-rota-salva';
                            this.$root.msgs.push(new Message('success', msg, true));

                            setTimeout(() => {
                                this.$emit('isChanged', false);
                                if (!this.isUpdate) this.redirectToEdit(body.content.idrota);
                            }, 500);
                        } else {
                            if (this.$te(body.message)) {
                                this.$root.msgs.push(new Message('alert', body.message, true));
                            } else {
                                this.$router.push(
                                    new Message('error', 'msg-problema-realizar-acao', true)
                                );
                            }
                        }
                    })
                    .catch((e) => {
                        this.$root.msgs.push(
                            new Message('error', 'msg-problema-realizar-acao', true)
                        );
                    })
                    .finally((_) => {
                        this.isSaving = false;
                    });
            }
        },
        redirectToEdit(id) {
            setTimeout(() => {
                this.$router.push({
                    name: 'rota-edit',
                    params: { id: id },
                });
            }, 1000);
        },
    },
};
</script>

<style lang="scss" scoped>
.form {
    width: 100%;
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;
    text-align: left;
}
</style>
